/* eslint-disable max-len */
import React from 'react'
import { OuterWrapper, InnerWrapper, MainHeading, CommonP } from './GlobalStyles';

export const Tech = () => {
  return (
    <OuterWrapper primary>
      <InnerWrapper>
        <MainHeading>TECH</MainHeading>
        <CommonP> HTML || CSS || Flexbox || Grid || JavaScript ES6 || Web Accessibly ||
             API:s || mob-programming || pair-programming || Github || Express.js || Node.js || MongoDB || Mongoose
        </CommonP>
      </InnerWrapper>
    </OuterWrapper>
  );
};
